<template>
  <div>
    <!-- Ashtapadi list -->
    <div>
      <vs-table
        id="ashtapadi-list"
        class="vs-con-loading__container"
        stripe
        :sst="true"
        maxHeight="800px"
        @search="updateSearchQuery"
        @change-page="handleChangePage"
        @sort="handleSort"
        :total="FilteredCount"
        :max-items="length"
        search
        :data="records"
      >
        <template slot="header">
          <div class="mb-2 flex items-center">
            <div class="flex flex-wrap justify-between items-center">
              <div class="mb-4 md:mb-0 mr-4 ag-grid-table-actions-left">
                <vs-dropdown vs-trigger-click class="cursor-pointer filter-font">
                  <div class="p-4 border border-solid d-theme-border-grey-light rounded-lg d-theme-dark-bg cursor-pointer flex items-center justify-between font-medium">
                    <span class="mr-2">
                      {{ page * length - (length - (FilteredCount && 1)) || 0 }}
                      -
                      {{ FilteredCount - page * length > 0 ? page * length : FilteredCount }}
                      of {{ total || 0 }}
                    </span>
                    <feather-icon icon="ChevronDownIcon" svgClasses="h-4 w-4" />
                  </div>
                  <vs-dropdown-menu>
                    <vs-dropdown-item @click="handleChangeLength(10)">
                      <span>10</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(20)">
                      <span>20</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(50)">
                      <span>50</span>
                    </vs-dropdown-item>
                    <vs-dropdown-item @click="handleChangeLength(100)">
                      <span>100</span>
                    </vs-dropdown-item>
                  </vs-dropdown-menu>
                </vs-dropdown>
              </div>
            </div>
            <div @click="addSlok" class="btn-add-new p-2 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-primary border border-solid border-primary">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add Slok</span>
            </div>
            <div @click="addPauri" class="btn-add-new p-2 mr-4 rounded-lg cursor-pointer flex items-center justify-center text-lg font-medium text-primary border border-solid border-primary">
              <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" />
              <span class="ml-2 text-base text-primary">Add Pauri</span>
            </div>
            <div class="flex flex-wrap items-center">
              <!-- Custom Pagination -->
              <vs-pagination v-if="FilteredCount" v-model="page" :total="totalPages" :max="totalPages / length > 7 ? 7 : 5" class="mt-1"></vs-pagination>
            </div>
          </div>
        </template>

        <template slot="thead">
          <vs-th>Sr#</vs-th>
          <vs-th sort-key="title">Title</vs-th>
          <vs-th sort-key="type">Type</vs-th>
          <vs-th sort-key="status">Visible</vs-th>
          <!-- <vs-th sort-key="general_index">Order</vs-th> -->
          <vs-th>Action</vs-th>
        </template>

        <template slot-scope="{ data }">
          <vs-tr :data="tr" :key="i" v-for="(tr, i) in data">
            <vs-td>
              {{ page * length - (length - i - 1) }}
            </vs-td>
            <vs-td class="text-left">
              <span class="cursor-pointer" @click.stop="toggleEditModal(tr._id, tr.type, $event)" v-tooltip="{ content: `Edit ${tr.title}` }">{{ tr.title || '-' }}</span>
            </vs-td>
            <vs-td class="text-left">
              <vs-chip :color="tr.type == 'Pauri' ? 'success' : 'warning'">{{ tr.type || '-' }} </vs-chip>
            </vs-td>
            <vs-td class="text-left">
              <vs-switch icon-pack="feather" vs-icon-on="icon-check-circle" vs-icon-off="icon-slash" color="primary" :value="tr.is_active" @click.stop="updateStatus(tr._id, !tr.is_active)">
                <span slot="on"></span>
                <span slot="off"></span>
              </vs-switch>
            </vs-td>
            <!-- <vs-td class="text-left w-1/6">
              <vs-input v-if="tr.general_index !== null" v-model="tr.general_index" type="number" v-validate="'digits'" class="w-1/2" @keydown.enter="updateIndex(tr.general_index, tr._id)" />
              <span v-else> - </span>
            </vs-td> -->
            <vs-td>
              <div class="inline-flex">
                <vx-tooltip :text="`Edit ${tr.type}`">
                  <feather-icon @click.stop="toggleEditModal(tr._id, tr.type, $event)" icon="EditIcon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" />
                </vx-tooltip>
                <vx-tooltip :text="`Delete ${tr.type}`">
                  <feather-icon @click.stop="deleteRecord(tr._id)" icon="Trash2Icon" svgClasses="h-5 w-5 mr-4 hover:text-primary cursor-pointer" />
                </vx-tooltip>
              </div>
            </vs-td>
          </vs-tr>
        </template>
      </vs-table>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'PauriSlokList',

  /** Data */
  data: () => ({
    order: [],
    length: 100,
    page: 1,
    search: '',
    module_name: 'pauri',
    active: false,
    active2: true,
    active3: false,
    selected: [],
    users: [],
    breadcrumb: []
  }),

  /** computed */
  computed: {
    ...mapState('pauri', ['records', 'total', 'FilteredCount', 'listLoading']),
    totalPages() {
      return Math.ceil(this.FilteredCount / this.length)
    }
  },

  /** Functions */
  methods: {
    handleSelected(tr) {
      this.$vs.notify({
        title: `Selected ${tr.username}`,
        text: `Email: ${tr.email}`
      })
    },

    ...mapActions('pauri', {
      get: 'getPaurisbyBook',
      delete: 'delete'
    }),

    /** Per Page Limit Change */
    handleChangeLength(length) {
      this.page = 1
      this.length = length
      this.getData()
    },

    /** Page Change */
    handleChangePage(page) {
      this.page = page
      this.getData()
    },

    /** Sorting Table Data */
    handleSort(key, active) {
      if (!key) return
      this.page = 1
      this.order = [key, active === 'desc' ? 'DESC' : 'ASC']
      this.getData()
    },

    /** Search Query */
    updateSearchQuery(val) {
      this.page = 1
      this.search = val
      this.getData()
    },

    /** Ashtapadi List API */
    getData() {
      this.get({
        book: this.$route.params.id,
        ashtapadi: this.$route.params.ashtapadiId,
        limit: this.length,
        page: this.page,
        search: this.search
      })
    },

    addSlok() {
      this.$router.push(`/book/${this.$route.params.id}/ashtapadi/${this.$route.params.ashtapadiId}/pauri/add/Slok`)
    },
    addPauri() {
      this.$router.push(`/book/${this.$route.params.id}/ashtapadi/${this.$route.params.ashtapadiId}/pauri/add/Pauri`)
    },

    // Edit Ashtapadi modal
    toggleEditModal(id, type, event) {
      let editUrl = null
      if (type === 'Pauri') {
        editUrl = `/book/${this.$route.params.id}/ashtapadi/${this.$route.params.ashtapadiId}/pauri/edit/${id}/Pauri`
      } else {
        editUrl = `/book/${this.$route.params.id}/ashtapadi/${this.$route.params.ashtapadiId}/pauri/edit/${id}/Slok`
      }
      if (event.ctrlKey || event.metaKey) {
        // Let browser handle the default Ctrl + Click behavior
        window.open(editUrl, '_blank')
      } else {
        // Navigate in the same tab
        this.$router.push(editUrl)
      }
    },

    /** Delete Ashtapadi Confirmation */
    deleteRecord(id) {
      this.$vs.dialog({
        type: 'confirm',
        color: 'primary',
        title: `Confirm Delete`,
        text: `Are you sure you want to delete this record?`,
        accept: () => this.deleteSingleRecord(id),
        acceptText: 'Delete'
      })
    },

    /** Delete Ashtapadi API */
    async deleteSingleRecord(id) {
      try {
        const { message } = await this.delete(id)
        this.$vs.notify({
          title: 'Success',
          text: message,
          iconPack: 'feather',
          icon: 'icon-alert-circle',
          position: 'top-center',
          time: 5000,
          color: 'success'
        })
        this.getData()
      } catch ({ message }) {
        this.$vs.notify({
          title: 'Error',
          text: message,
          iconPack: 'feather',
          position: 'top-center',
          time: 5000,
          icon: 'icon-alert-circle',
          color: 'primary'
        })
      }
    },

    /** updateStatus API */
    updateStatus(id, status) {
      this.$store
        .dispatch('pauri/updateStatus', {
          id,
          status
        })
        .then((Success) => {
          const { message } = Success
          this.$vs.notify({
            title: 'Success',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'top-center',
            time: 5000,
            color: 'success'
          })
          this.getData()
        })
        .catch((err) => {
          const { message } = err
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'top-center',
            time: 5000,
            color: 'primary'
          })
        })
    },

    /** Update General-Index */

    updateIndex(general_index, id) {
      this.$store
        .dispatch('pauri/manageIndexNumber', {
          general_index,
          id
        })
        .then((Success) => {
          this.getData()
          const { message } = Success
          this.$vs.notify({
            title: 'Success',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'top-center',
            time: 5000,
            color: 'success'
          })
        })
        .catch((err) => {
          this.getData()
          const { message } = err
          this.$vs.notify({
            title: 'Error',
            text: message,
            iconPack: 'feather',
            icon: 'icon-alert-circle',
            position: 'top-center',
            time: 5000,
            color: 'primary'
          })
        })
    }
  },

  /** Watchers */
  watch: {
    breadcrumb(newvalue) {
      this.$emit('update-breadcrumb', newvalue)
    },
    listLoading() {
      if (this.listLoading) {
        this.$vs.loading({
          container: '#ashtapadi-list',
          scale: 0.45
        })
      } else {
        this.$vs.loading.close('#ashtapadi-list > .con-vs-loading')
      }
    },
    page() {
      this.getData()
    }
  },

  /** On Rendering */
  async mounted() {
    this.getData()
    const id = this.$route.params.id
    if (id) {
      const parentRes = await this.$store.dispatch('book/show', id)
      const parentData = parentRes.data.data

      const res = await this.$store.dispatch('ashtapadi/show', this.$route.params.ashtapadiId)
      const resData = res.data.data
      this.breadcrumb = [
        { title: 'Dashboard', url: '/dashboard' },
        { title: 'Book', url: '/book/list' },
        { title: parentData.title, url: `/book/${id}/ashtapadi` },
        { title: resData.title, active: true },
        { title: 'Pauri & Slok List', active: true }
      ]
    }
  }
}
</script>
